import {getElement} from "./utils";

const disableScroll = () => {
    const htmlElement = getElement('html');

    if (htmlElement.classList.contains('is-scroll-disabled')) {
        htmlElement.classList.remove('is-scroll-disabled');
    } else {
        htmlElement.classList.add('is-scroll-disabled');
    }
}

export {disableScroll}